import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    ChamberCreate,
    ChamberDelete,
    ChamberEdit,
    ChamberListParams, ChamberPort, ChamberPortAdd, ChamberPortEdit,
    ChamberUserPort,
    ChamberUsersPort,
    ChamberWithPage,
} from '@app/interfaces/rm/chamber';
import { Radio } from '@app/interfaces/rm/radio';
import { OptionsParams, RemoteOptionWithPage, RemoteParams, SelectOption } from '@app/interfaces/sys/dict';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ChamberHttp {
    private moduleApi = environment.api.services.rm;

    private baseUrl = this.moduleApi + '/chambers';

    constructor(private http: HttpClient) {
    }

    async chamberList(option: ChamberListParams): Promise<ChamberWithPage> {
        return lastValueFrom(this.http.get<ChamberWithPage>(this.baseUrl, {
            params: Object.assign(option),
        }));
    }

    async options(params?: OptionsParams): Promise<SelectOption[]> {
        return lastValueFrom(this.http.get<SelectOption[]>(`${this.baseUrl}/all-options`, {
            params: params ? Object.assign(params) : {}
        }));
    }

    async chamberCreate(option: ChamberCreate): Promise<void> {
        return lastValueFrom(this.http.post<void>(this.baseUrl, option));
    }

    async chamberEdit(option: ChamberEdit): Promise<void> {
        return lastValueFrom(this.http.put<void>(this.baseUrl, option));
    }

    async editChamberUser(option: ChamberUsersPort): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.moduleApi}/user-chambers`, option));
    }

    async deleteChamberUser(option: ChamberUserPort): Promise<any> {
        return lastValueFrom(this.http.request<void>('DELETE', `${this.moduleApi}/user-chambers`, {
            body: Object.assign(option),
        }));
    }

    async chamberDelete(option: ChamberDelete): Promise<void> {
        return lastValueFrom(this.http.request<void>('DELETE', this.baseUrl, {
            body: Object.assign(option),
        }));
    }

    async chamberOneDetail(option: { id: number }): Promise<any> {
        return lastValueFrom(this.http.get<Radio>(`${this.baseUrl}/one`, {
            params: Object.assign(option),
        }));
    }

    async chamberOptions(params: RemoteParams): Promise<RemoteOptionWithPage> {
        return lastValueFrom(this.http.get<RemoteOptionWithPage>(`${this.moduleApi}/chamber-ports/options`, {
            params: Object.assign(params)
        }));
    }

    async chamberPortAdd(option: ChamberPortAdd): Promise<ChamberPort> {
        return lastValueFrom(this.http.post<ChamberPort>(`${this.moduleApi}/chamber-ports`, option))
    }

    async deleteChamberPort(option: {id: number}): Promise<void> {
        return lastValueFrom(this.http.request<void>('DELETE', `${this.moduleApi}/chamber-ports`, {
            body: Object.assign(option),
        }))
    }

    async chamberPortEdit(option: ChamberPortEdit): Promise<ChamberPort> {
        return lastValueFrom(this.http.put<ChamberPort>(`${this.moduleApi}/chamber-ports`, option));
    }

    async getChamberName(params: {chamberId: number}): Promise<string[]> {
        return lastValueFrom(this.http.get<string[]>(`${this.moduleApi}/chamber-ports/options/name`, {
            params: Object.assign(params)
        }));
    }

    async getChamberNameByInstanceId(params: {resourceInstanceId: number}): Promise<string[]> {
        return lastValueFrom(this.http.get<string[]>(`${this.moduleApi}/chamber-ports/options/name/resource-instance`, {
            params: Object.assign(params)
        }));
    }
}
